<template>
  <div>
    <template v-if="routeMatchesComponent()">
      <!-- TODO Improves -->
      <div v-show="statusMessage !== '' " class="mt2 mx3" :class="{ 'success': success, 'danger': !success }">
        <span>{{ statusMessage }}</span>
      </div>
      <div v-if="firstLoad" class="m3 my3">
        <div class="semi-bold p3 white-bg flex my3 flex-column justify-center center">
          <span>{{ getReferencelabel("OPTIONS_TEXT1") }} </span>
          <span>{{ getReferencelabel("OPTIONS_TEXT2") }} </span>
          <span>{{ getReferencelabel("OPTIONS_TEXT") }} </span>
        </div>
        <div v-if="!ordersListing.value.length" class="p3 white-bg flex my3">
          <span class="flex flex-auto h5n semi-bold justify-center">{{ getReferencelabel("FIND_HERE") }}</span>
        </div>
        <div v-for="(order, index) in ordersListing.value" v-else :key="index" class="py1 white-bg my3">
          <div class="col-12 flex flex-wrap py1">
            <div class="col-12 flex flex-column items-center">
              <span class="blue h3n bold center">{{ genericOrderObject(order).productName }}</span>
              <p class="h4n bold m0 py2 center"><!-- {{ order.center_destination_name }}, --> {{ genericOrderObject(order).date }}</p>
              <router-link :to="{ name: 'DetailsOrderOptions', params: { uuid: order.bookingNumber} }" class="h5n blue semi-bold underline">{{ getReferencelabel("MORE") }}</router-link>
            </div>
            <div v-if="userUuid && !order.isPaid" class="col-12 flex justify-center mt1">
              <Button reference="CANCEL" class="inline-block col-8 md-col-6 lg-col-4 my2 mx1" btn-color="blue" :action="openModal.bind(this, order)" />
              <Button v-if="order.paymentDetails && order.paymentDetails.pay_remaining_link" reference="PAY" class="inline-block col-8 md-col-6 lg-col-4 my2 mx1" btn-color="red" :action="goToPaymentSolde.bind(this, order)" />
            </div>
          </div>
        </div>

        <div v-if="showMoreButton" class="flex flex-wrap justify-center">
          <Button reference="SEE_MORE" class="col-8 md-col-6 lg-col-4 mb3" btn-color="inverted" :action="loadMoreOrders" />
        </div>
      </div>
    </template>
    <Modal v-if="showModal" @close="closeModal">
      <template #body>
        <div class="col-12 flex flex-column items-center justify-center white-bg modal-qrcode-dimensions">
          <span class="h4n bold mb3">{{ getReferencelabel("CONFIRM") }}</span>
          <div class="flex col-12">
            <Button reference="NO" class="inline-block col-6 mt2 mx1" btn-color="blue" :action="closeModal.bind(this)" />
            <Button reference="YES" class="inline-block col-6 mt2 mx1" btn-color="red" :action="cancel.bind(this, selectedOrder)" />
          </div>
        </div>
      </template>
    </Modal>
    <router-view v-else @orderDetailsLoaded="orderDetailsLoadedhandler" />
  </div>
</template>

<script>

import { onMounted, ref, reactive, computed, provide, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Button from '@/components/elements/Button';
import { getReferencelabel, routeIsCurrentComponent, isInImpersonateModeNotification } from '@/mixins/utils';
import Modal from '@/components/blocks/Modal';

import { getOrders, cancelOption } from '@/mixins/requests';

export default {
  components: {
    Button,
    Modal
  },
  setup () {
    const store = useStore();
    const route = useRoute();
    const showModal = ref(false);
    const success = ref(false);
    const statusMessage = ref('');
    const firstLoad = ref(false);
    const start = ref(0);
    const limit = ref(3);
    const ordersCount = ref(0);
    const ordersListing = reactive([]);
    const userUuid = ref(store.state.user.uuid);
    const userIresaIds = ref(store.state.user.iresa_ids);
    const selectedOrder = ref(null);

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const orderDetailsLoaded = ref(true);

    const showMoreButton = computed(() => ordersCount.value > ordersListing.value.length);

    function goToPaymentSolde (order) {
      // window.open(
      //   `/reservation/paiementsolde?booking=${order.bookingNumber}&customer=${order.customer_id}`,
      //   '_blank'
      // ); // <-- This is how it opens a new tab

      window.open(order.paymentDetails.pay_remaining_link);
    }

    function openModal (order) {
      statusMessage.value = '';
      selectedOrder.value = order;
      showModal.value = true;
    }

    function closeModal () {
      showModal.value = false;
    }

    async function cancel (order) {
      closeModal();
      if (isInImpersonateModeNotification()) {
        return;
      }
      store.commit('setLoading', true);
      const response = await cancelOption(order.bookingNumber);
      if (response && response.success) {
        statusMessage.value = getReferencelabel('CANCEL_SUCCESS');
        success.value = true;
      } else {
        statusMessage.value = getReferencelabel('CANCEL_ERROR');
        success.value = false;
      }
      await syncOrders();
      store.commit('setLoading', false);
    }

    function orderDate (data) {
      return `${data.order.start_date} - ${data.order.end_date}`;
    }

    async function loadMoreOrders () {
      start.value += limit.value;
      await syncOrders();
    }

    function genericOrderObject (data) {
      // if (data.order_source === 'alpha') {
      //   return {
      //     productName: data.order.order_items[0].product_name,
      //     description: data.order.order_items[0].horanet_product_name,
      //     date: data.date,
      //     status: data.order.status
      //   };
      // }
      return {
        productName: data.mainProduct,
        description: data.mainProduct,
        date: `${data.startDate} - ${data.endDate}`,
        status: data.status
      };
    }

    async function syncOrders () {
      store.commit('setLoading', true);
      const { count, items } = await getOrders(start.value, limit.value, 'Option');

      ordersCount.value = count;
      ordersListing.value = [...ordersListing.value || [], ...items];

      if (orderDetailsLoaded.value) {
        store.commit('setLoading', false);
      }
    }

    function orderDetailsLoadedhandler (value) {
      orderDetailsLoaded.value = value;
    }

    onMounted(async () => {
      await syncOrders();
      firstLoad.value = true;
    });

    return {
      firstLoad,
      start,
      limit,
      ordersCount,
      ordersListing,
      userUuid,
      showMoreButton,
      goToPaymentSolde,
      orderDate,
      loadMoreOrders,
      syncOrders,
      route,
      getReferencelabel,
      cancel,
      openModal,
      closeModal,
      showModal,
      selectedOrder,
      success,
      statusMessage,
      orderDetailsLoadedhandler,
      routeMatchesComponent,
      genericOrderObject
    };
  }
};
</script>

<style>

</style>
